export default function () {
  return {
    offerYear: undefined,
    agreements: undefined,
    isLoadingAgreements: false,
    hasLoadedEditPossible: false,
    hasBasicInsurance: false,
    agreementDetails: undefined,
    hasKnownIban: undefined,
    hasIbanPayedByInsured: undefined,
    notShowAnyMore: false,
    agreementDetailsForOfferYear: undefined,
  };
}
